import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import FileFieldBase from 'components/form/field/file'
import FileNameIconBase from 'components/file-name-icon'

export const FileField = styled(FileFieldBase)`
    margin-bottom: 32px;
`

export const Meta = styled.div`
    margin-bottom: 24px;
`

export const FileNameIcon = styled(FileNameIconBase)`
    svg.feather {
        ${svgStroke()}
    }
`